import R from 'ramda'

const FACEBOOK_DM_WIDGET_TYPE = 'SEND_FACEBOOK_MESSAGE'
const FACEBOOK_RECURRING_DISPLAY_TYPE = 'Send Facebook Recurring Consent'

const isRecurringRequest = R.pathEq(
  ['message', 'message', 'attachment', 'payload', 'template_type'],
  'notification_messages'
)
const hasWidgetDmType = R.propEq('type', FACEBOOK_DM_WIDGET_TYPE)
const isRecurringConsentAction = R.both(isRecurringRequest, hasWidgetDmType)

const convertFacebookRecurringConsentWidgetActionToFormAction = R.applySpec({
  type: R.always(FACEBOOK_RECURRING_DISPLAY_TYPE),
  recurringConsentTitle: R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'title'
  ]),
  recurringConsentImageUrl: R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'image_url'
  ])
})

export {
  isRecurringConsentAction,
  convertFacebookRecurringConsentWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/facebook-recurring-consent.js